/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	Label,
	FlexItem,
	FlexLayout,
	SVGIcon
} from '@ba/ba-ui-carbon-toolkit';
import checkmarkFilled from '@ba/ba-graphics/dist/icons-js/checkmark--filled_16';
import '../../../stylesheets/all.scss';

export default class VisualItem extends Component {

	static propTypes = {
		item: PropTypes.object.isRequired,
		fileRef: PropTypes.string.isRequired,
		selected: PropTypes.bool.isRequired,
		idx: PropTypes.number.isRequired,
		items: PropTypes.array.isRequired,
		files: PropTypes.array.isRequired,
		selections: PropTypes.array.isRequired,
		selectVisualItemCallback: PropTypes.func.isRequired,
		handleVisualItemContextMenuCallback: PropTypes.func.isRequired
	};

	constructor(props) {
		super(props);

		this.state = {
			isContextMenuOpen: false
		};
	}

	_onClickHandler = (e) => {
		e.stopPropagation();
		this.props.selectVisualItemCallback( this.props.idx, e.ctrlKey || e.metaKey );
	}

	_onKeyDownHandler = (e) => {
		// implement
		if (e.keyCode === 32 || e.keyCode === 13) {
			// TODO - we should cancel the event
			// but this is react event so outside normal event processing
			// see https://medium.com/@ericclemmons/react-event-preventdefault-78c28c950e46
			// use native event to stop this
			this.props.selectVisualItemCallback(this.props.idx, e.ctrlKey || e.metaKey);
		}
	}

	_showVisualItemContextMenu = ( idx ) => {
		this.props.selectVisualItemCallback( idx );
		this.props.handleVisualItemContextMenuCallback();
		this.setState({ isContextMenuOpen : !this.state.isContextMenuOpen });
	}

	_closeVisualItemContextMenu = () => {
		this.setState({ isContextMenuOpen: false });
	}

	_renderItem = ( fileRef ) => {
		return (
			<FlexLayout
				direction='column'
				role={'button'}
				onClick={ this._onClickHandler }
				onKeyDown={ this._onKeyDownHandler }>
				<FlexItem style={ { width: '128px', height: '128px' } } >
					{ this._renderContent( fileRef ) }
				</FlexItem>
			</FlexLayout>
		);
	}

	_renderContent = ( fileRef ) => {
		// all urls are represented as blobs in our files data
		// (implies that any integrator would extract and supply as blobs)
		return (
			<FlexLayout
				direction='column'
				width='100%'
				height='100%'
				alignItems='center'
				justifyContent='center'
			>
				<FlexItem style={{ width:'100%' }} >
					<FlexItem>
						<img style={{ width:'100%', height:'auto', maxWidth:'108px', maxHeight:'108px' }}
							src = { fileRef }
						/>
					</FlexItem>
				</FlexItem>
			</FlexLayout>
		);
	}

	_renderItemLabel = ( item ) => {
		return (
			<Label label={item.caption} ellipsis={true}/>
		);
	}

	//
	// Main render function
	//
	render() {
		const className = 'clsSVGTileStyle' + ( this.props.selected ? '_selected' : '' );

		return (
			<FlexItem className="clsSVGTileStyleContainer">
				<div ref={this._rootRef} style={ { width:'128px' } }>
					<FlexLayout
						fullHeight={true}
						direction='column'
						alignItems='flex-start'
						className={className}
						onClick={ this._onClickHandler }
						onKeyDown={ this._onKeyDownHandler }
						tabIndex={0}
					>
						<FlexItem alignSelf='flex-end' className="clsSVGTileCheckmark">
							<SVGIcon
								size='small'
								className='svgIcon clsSVGCheckmarkSelected'
								verticalAlign={'initial'}
								iconId={checkmarkFilled.id}
								tabIndex={-1}
							/>
						</FlexItem>
						<FlexItem>
							{this._renderItem( this.props.fileRef, this.props.selected, this.props.idx)}
						</FlexItem>
						<FlexItem alignSelf='center'
						>
							{this._renderItemLabel(this.props.item)}
						</FlexItem>
					</FlexLayout>
				</div>
			</FlexItem>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/dialog/schematic/VisualItem.js